module.exports = new __parcel__URL__("product-requirements.d1bb667a.png").toString();